export const HEADER_CONSTS = {
  preview: 'Предпросмотр',
  save: 'Сохранить',
  savingMsg: 'Сохраняется'
}
